import React from 'react';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { SubmittedEvaluationBlock, SubmittedEvaluationItem } from '../../../../adminv3/types/courseExams';
import './submittedEvaluationBlock.module.scss';
import classNames from 'classnames';

type BlockProps = {
  passed: boolean;
  submittedEvaluationBlock: SubmittedEvaluationBlock;
  loading: boolean;
};

const sum = (arr) => arr.reduce((prev, current) => prev + current, 0);

export const SubmittedEvaluationBlockPane = ({ passed, submittedEvaluationBlock, loading }: BlockProps) => {
  const itemScoreResultArray = submittedEvaluationBlock.items.map((item) => item.scoreResult).filter(Boolean);
  const blockScoreResult = sum(itemScoreResultArray);
  const itemMaxScoreArray = submittedEvaluationBlock.items.map((item) => item.maxScore);
  const blockMaxScore = sum(itemMaxScoreArray);
  const blockScoreResultColor = passed ? 'block-score-result-color-blue' : 'block-score-result-color-red';

  return (
    <div styleName="evaluation-block-wrapper" data-id={submittedEvaluationBlock.id}>
      <div styleName="evaluation-block-label">{submittedEvaluationBlock.label}</div>
      <div styleName="evaluation-block">
        {submittedEvaluationBlock.items.map((blockItem, index) => (
          <SubmissionEvaluationResultBlockItem
            key={blockItem.id}
            index={index}
            passed={passed}
            submittedEvaluationItem={blockItem}
          />
        ))}
      </div>
      {loading && <LoaderRow />}
      <div styleName="evaluation-block-score-wrapper">
        <span>合計</span>
        <span styleName={classNames('evaluation-block-score-result', blockScoreResultColor)}>{blockScoreResult}</span>
        <span>点 / {blockMaxScore}点満点</span>
      </div>
    </div>
  );
};

type BlockItemProps = {
  index: number;
  passed: boolean;
  submittedEvaluationItem: SubmittedEvaluationItem;
};

export const SubmissionEvaluationResultBlockItem = ({ index, passed, submittedEvaluationItem }: BlockItemProps) => {
  const backgroudColor = passed ? 'background-color-blue' : 'background-color-red';
  const oddLineBackgroudColor = index % 2 != 0 ? backgroudColor : null;
  return (
    <div
      styleName={classNames('evaluation-block-item-wrapper', oddLineBackgroudColor)}
      data-id={submittedEvaluationItem.id}
    >
      <div styleName="evaluation-block-item-score-result-wrapper">
        <span styleName="evaluation-block-item-score-result">{submittedEvaluationItem.scoreResult}</span>
      </div>
      <div styleName="evaluation-block-item-label">{submittedEvaluationItem.label}</div>
    </div>
  );
};
